module.exports = __webpack_public_path__ + "img/xx.84868883.png";